import { render, staticRenderFns } from "./SalespersonJoin.vue?vue&type=template&id=4ece4695"
import script from "./SalespersonJoin.vue?vue&type=script&lang=js"
export * from "./SalespersonJoin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports